import React from 'react';
import styled from 'styled-components';
import MUIButton, { ButtonProps } from '@mui/material/Button';

import { FONT_SIZES, PALETTE } from '~/assets/styles/base';

// ベーシックなボタンを定義 テーマはsrc/assets/styles/overrideMUI.jsにて定義
type StyledButtonProps = {
  $width?: string;
  $colorType?: string;
  rel?: string;
  target?: string;
  $fontSize: string;
};

const StyledButton = styled(MUIButton)<StyledButtonProps>`
  text-transform: none;
  font-size: ${({ $fontSize }) => $fontSize};
  width: ${({ $width }) => $width};
  &.MuiButton-contained {
    ${(props) => {
      if (props.$colorType === 'gray') {
        return `
          color: ${PALETTE.white};
          background-color: #B2BDC5;
          box-shadow: 2px 2px 4px #00000014;
        `;
      }
      if (props.$colorType === 'yellow') {
        return `
            color: #052e4f;
            background-color: ${PALETTE.yellow.dark};
            box-shadow: 2px 2px 4px #00000014;
        `;
      }
      if (props.$colorType === 'red') {
        return `
            color: ${PALETTE.white};
            background-color:  ${PALETTE.error.main};
            box-shadow: 2px 2px 4px #00000014;
        `;
      }
      return '';
    }}
  }
  &.MuiButton-outlined {
    ${(props) => {
      if (props.$colorType === 'gray') {
        return `
          color: ${PALETTE.gray[300]};
          border-color: ${PALETTE.gray[400]};
        `;
      }
      if (props.$colorType === 'navy') {
        return `
            color: ${PALETTE.navy.main};
            border-color:  ${PALETTE.navy.main};
        `;
      }
      return '';
    }}
  }
`;

type Props = {
  variant?: ButtonProps['variant'];
  color?: ButtonProps['color'];
  colorType?: string;
  width?: string;
  handleClick?: ButtonProps['onClick'];
  dataTestId?: string;
  children: JSX.Element | string | React.ReactNode;
  rel?: string;
  target?: string;
  fontSize?: string;
};

const Button: React.FC<Props & ButtonProps> = ({
  variant = 'outlined',
  color = 'primary',
  colorType,
  handleClick = () => {},
  dataTestId,
  children,
  width,
  rel,
  target,
  fontSize = FONT_SIZES.body3,
  ...props
}): JSX.Element => (
  <StyledButton
    data-testid={dataTestId ? `uiElements-Button-${dataTestId}` : `uiElements-Button`}
    variant={variant}
    color={color}
    onClick={(e) => handleClick(e)}
    $colorType={colorType}
    $width={width}
    rel={rel}
    target={target}
    $fontSize={fontSize}
    {...props}
  >
    {children}
  </StyledButton>
);

export default Button;
